<template>
  <div class="meta-item-back m-4">
    <i class="icon icon-bor-arrow-left" />
    <a class="text-black" @click="handleBack">お申し込み一覧に戻る</a>
  </div>
</template>

<script>
export default {
  name: 'BackToPrevious',
  methods: {
    handleBack() {
      const query = this.$route.query
      this.$router.push({path: '/mypage/orders'}, query)
    }
  }
}
</script>

<style scoped>
@import "./styles.scss";
</style>
